import React from 'react'
import NavbarLink from './NavbarLink'

function NavbarLinks({setCategoriaDesplegada,categoriaDesplegada,menuAbierto,setCategoriaDesplegadaRes, setMenuAbierto}) {
  return (
    menuAbierto ? 
    <div className={'flex w-full flex-col text-xl items-start text-start'}>
    <NavbarLink href={'#'} setMenuAbierto={setMenuAbierto} menuAbierto={menuAbierto} contenido={'Categoría'} setCategoriaDesplegadaRes={setCategoriaDesplegadaRes } setCategoriaDesplegada={setCategoriaDesplegada} categoriaDesplegada={categoriaDesplegada } />
    <NavbarLink href={'#'} setMenuAbierto={setMenuAbierto} menuAbierto={menuAbierto} contenido={'Marcas'}/>
    <NavbarLink href={'#'} setMenuAbierto={setMenuAbierto} menuAbierto={menuAbierto} contenido={'Post-Venta'}/>
    <NavbarLink href={'#'} setMenuAbierto={setMenuAbierto} menuAbierto={menuAbierto} contenido={'Contacto'}/>
    <NavbarLink href={'#'} setMenuAbierto={setMenuAbierto} menuAbierto={menuAbierto} contenido={'Sobre Nosotros'}/>
   </div>
      :
    <div className={`hidden md:mx-5 md:flex sm:w-8/12 sm:text-sm lg:text-base justify-evenly xl:w-7/12  xl:justify-evenly`}>
    <NavbarLink href={'#'} contenido={'Categoría'} setCategoriaDesplegada={setCategoriaDesplegada} categoriaDesplegada={categoriaDesplegada } />
        <NavbarLink href={'#'} contenido={'Marcas'} setCategoriaDesplegada={setCategoriaDesplegada } />
    <NavbarLink href={'#'} contenido={'Post-Venta'} setCategoriaDesplegada={setCategoriaDesplegada }/>
    <NavbarLink href={'#'} contenido={'Contacto'} setCategoriaDesplegada={setCategoriaDesplegada }/>
    <NavbarLink href={'#'} contenido={'Sobre Nosotros'} setCategoriaDesplegada={setCategoriaDesplegada }/>
   </div>
  )
}

export default NavbarLinks